<template>
  <div class="w-full h-full overflow-auto relative">
    <div
      class="h-full flex items-center max-w-2xl mx-auto flex-col justify-center relative"
    >
      <div class="flex flex-col gap-2">
        <div>
          <img
            src="/images/buyGiftCard.png"
            class="max-w-[500px] w-[70vw] mx-auto"
            alt=""
          />
        </div>
        <div class="text-center text-3xl font-bold">
          {{
            option.id == 'buy' || option.isBuying
              ? 'Achat de Carte Cadeau'
              : option.id == 'sell' || (option.id && !option.isBuying)
                ? 'Vente de Carte Cadeau'
                : 'Achat - Vente de Carte Cadeau'
          }}
        </div>

        <!-- {{ option }} -->
      </div>
      <div v-if="paymentPending" class="py-32">
        <div class="text-center px-4 pb-8 text-3xl" v-if="option.isBuying">
          En attente ce confirmation du paiement
        </div>
        <Loader />
      </div>

      <div
        v-else-if="paymentSucceeded"
        class="flex flex-col items-center justify-center py-12 pt-24"
      >
        <div class="w-[8rem]">
          <img src="@/assets/images/all/check.png" alt="" />
        </div>
        <div class="py-4"></div>
        <div class="text-3xl title-color">
          {{ option.isBuying ? 'Paiement réussi' : 'Transaction initiée' }}
        </div>
        <div class="text-center">
          Vous recevrez un email de confirmations sur
          {{ filledData?.recipientEmail }}
        </div>
      </div>

      <div
        v-else-if="paymentFailed"
        class="flex flex-col items-center justify-center py-12 pt-24"
      >
        <div class="w-[7rem]">
          <img src="@/assets/images/all/close-blue.svg" alt="" />
        </div>
        <div class="py-4"></div>
        <div class="text-3xl text-center title-color">Paiement échoué</div>
        <div class="py-1" v-if="failureDescription">
          <div class="text-center title-color">
            Désolé, votre paiement n'a pas été confirmé. Veuillez réessayer
          </div>
        </div>
      </div>
      <div v-else-if="selectOption" class="w-full px-4">
        <SubscriptionSelector
          :defaultOptionId="preselectedServiceOption"
          v-if="service.serviceId == 'subscription'"
          @optionSelected="
            option => {
              subscriptionSelected(option)
            }
          "
        />
        <TransactionOptionSelector
          v-else
          :defaultOptionId="preselectedServiceOption"
          :service="service"
          @noOptionFound="onNoOptionFound"
          @optionSelected="transactionOptionSelected"
        />
      </div>
      <div
        class="w-full px-4"
        v-else-if="
          fillForm && !option.isGiftCard && service.serviceId == 'giftCard'
        "
      >
        <GiftCardSelector
          v-if="service.serviceId == 'giftCard'"
          :option="option"
          @cardSelected="
            card => {
              giftCardSelected(card)
            }
          "
        />
        <div
          class="text-center"
          v-if="option?.id"
          @click="
            () => {
              onServiceRequested({
                serviceId: 'giftCard',
                option: this.getOptionId(),
              })
            }
          "
        >
          Retour
        </div>
      </div>
      <div v-else-if="fillForm" class="w-full px-4">
        <SellGiftCardForm
          :card="option"
          isDirect
          requestPhoneCountry
          hidePaymentMethod
          v-if="service.serviceId == 'giftCard' && !option.isBuying"
          @dataFilled="onDataFilled"
          ref="giftCardForm"
        />
        <BuyGiftCardForm
          :card="option"
          isDirect
          requestPhoneCountry
          hidePaymentMethod
          v-else-if="service.serviceId == 'giftCard' && option.isBuying"
          @dataFilled="onDataFilled"
          ref="giftCardForm"
        />
        <div
          class="text-center"
          v-if="option?.id"
          @click="
            () => {
              onServiceRequested({
                serviceId: 'giftCard',
                option: this.getOptionId(),
              })
            }
          "
        >
          Retour
        </div>
      </div>
    </div>
    <TransactionLauncheListener @transactionLaunched="onTransactionLaunched" />
    <EventListener
      uniqId="transaction_launcher_handler"
      :events="[
        'service_launching_requested',
        'service_launching_prefilled_requested',
        'launch_transaction_request',
      ]"
      @service_launching_requested="onServiceRequested"
      @service_launching_prefilled_requested="launchPreFilledService"
      @launch_transaction_request="onTransactionRequestSent"
    />
    <LaunchedTransactionResolver
      @transactionPaymentDone="onTransactionPaymentDone"
    />
    <OtpValidation ref="otpValidator" @otp_validated="onOtpValidated" />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import TransactionOptionSelector from './TransactionOptionSelector.vue'
import TransactionLauncheListener from './TransactionLauncheListener.vue'
import EventListener from '../../utils/EventListener.vue'
import GiftCardSelector from './GiftCardSelector.vue'
import SellGiftCardForm from './forms/SellGiftCardForm.vue'
import BuyGiftCardForm from './forms/BuyGiftCardForm.vue'
import OtpValidation from '@/components/utils/OtpValidation.vue'
import LaunchedTransactionResolver from './LaunchedTransactionResolver.vue'
import Loader from '@/components/utils/Loader.vue'

export default defineComponent({
  name: 'SpecificTransactionLauncher',
  components: {
    TransactionOptionSelector,
    TransactionLauncheListener,
    EventListener,
    GiftCardSelector,
    SellGiftCardForm,
    BuyGiftCardForm,
    LaunchedTransactionResolver,
    OtpValidation,
    Loader,
  },
  props: {},
  data() {
    return {
      preselectedServiceOption: '',
      selectOption: false,
      fillForm: false,
      service: {},
      option: {},
      prefilledFormData: null,
      sendingOtp: false,
      paymentPending: false,
      paymentSucceeded: false,
      paymentFailed: false,
      filledData: {},
    }
  },
  mounted() {
    this.onServiceRequested({
      serviceId: 'giftCard',
      option: this.getOptionId(),
    })
  },
  methods: {
    getOptionId() {
      try {
        if (/sell/i.test(window.location.href)) return 'sell'
        if (/buy/i.test(window.location.href)) return 'buy'
      } catch (error) {
        return ''
      }
    },
    async onServiceRequested(service) {
      this.preselectedServiceOption = service.option || ''
      this.service = service
      this.selectOption = true
      this.fillForm = false
      this.prefilledFormData = null
    },
    async launchPreFilledService({ service, option, formData }) {
      this.service = service
      this.option = option
      this.selectOption = false
      this.fillForm = true
      this.prefilledFormData = formData
    },
    onNoOptionFound() {
      this.option = {}
      this.selectOption = false
      this.fillForm = true
    },
    transactionOptionSelected(option) {
      this.option = option
      this.selectOption = false
      this.fillForm = true
    },
    giftCardSelected(option) {
      this.option = option
      this.selectOption = false
      this.fillForm = true
    },
    subscriptionSelected(option) {
      this.option = option
      this.selectOption = false
      this.fillForm = true
    },

    onDataFilled(data) {
      if (this.sendingOtp) return
      this.sendingOtp = true
      this.filledData = data
      this.$refs.otpValidator.validateEmail({
        email: this.filledData.recipientEmail,
        firstName: 'Mr/Mme',
        // reason: 'passwordReset',
      })
      setTimeout(() => {
        this.sendingOtp = false
      }, 1000)
    },
    async onOtpValidated({ otp, token }) {
      const transactionData = {
        ...this.filledData,
        email: this.filledData.recipientEmail,
        isDirect: true,
        otp,
        token,
      }
      console.log(transactionData)
      await new Promise(r => setTimeout(r, 500))
      this.$refs.giftCardForm.startLoading()
      this.$Events.dispatchEvent('launch_transaction_request', transactionData)
      this.$Events.dispatchEvent('start_loading')
    },
    onTransactionLaunched() {
      if (this.option.isBuying) this.paymentPending = true
      else this.paymentSucceeded = true
    },
    onTransactionPaymentDone(data) {
      const status = data?.status
      if (!status) return
      this.paymentPending = false
      if (status == 'success') {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Paiement réussi',
          body: "Nous vous enverront un email pour que vous accédez à l'application Kingrecharge",
        })
        this.paymentSucceeded = true
      } else {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Paiement échoué',
          body: 'Le paiement a échoué. Veuillez réessayer à nouveau.',
        })
        this.paymentFailed = true
      }
    },
  },
})
</script>
